import {getCurrencyFractionDigits} from './getCurrencyFractionDigits';

const DECIMAL_BASE = 10;

// 20 000 EUR -> 2000000. Rounding absorbs the float error of the multiplication (199.99 * 100).
export const toMinorUnits = (amount: number, currency: string) =>
  Math.round(amount * DECIMAL_BASE ** getCurrencyFractionDigits(currency));
